import { LanguageEnum } from '../../../../utils';

export const copyWritings = {
  title: {
    [LanguageEnum.chinese]: 'VisActor/VGraph demo',
    [LanguageEnum.english]: 'VisActor/VGraph demo',
  },
  description: {
    [LanguageEnum.chinese]: 'VGraph demo:',
    [LanguageEnum.english]: 'VGraph demo:',
  },
};
